module.exports = __webpack_public_path__ + "static/media/avatars_male_23.243ae643.png";